module.exports = __webpack_public_path__ + "static/media/banner-full.ba4ed9ee.png";